import React from 'react';
import { useIntl } from 'react-intl';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import ErrorState from '@rio-cloud/rio-uikit/ErrorState';

import { DialogFooter } from '@/features/common/components/dialogs/common/DialogFooter';
import type { CloseDialogProps, RefetchDialogProps } from '@/features/common/components/dialogs/common/types';

type DialogErrorStateProps = CloseDialogProps & RefetchDialogProps;

export const DialogErrorState = ({ onClose, refetch }: DialogErrorStateProps) => {
    const intl = useIntl();
    return (
        <div className="bg-white min-height-200">
            <Dialog.Title
                title={intl.formatMessage({ id: 'intl-msg:common.error.emptyState.headline' })}
                onCloseButtonClick={onClose}
            />
            <Dialog.Body className={'padding-15 margin-left-15'}>
                <ErrorState
                    message={intl.formatMessage({ id: 'intl-msg:common.error.emptyState.message' })}
                    buttons={[
                        {
                            text: (
                                <>
                                    <span className="rioglyph rioglyph-refresh" />
                                    <span>{intl.formatMessage({ id: 'intl-msg:common.error.emptyState.button' })}</span>
                                </>
                            ),
                            className: 'foobar',
                            onClick: () => refetch(),
                        },
                    ]}
                />
            </Dialog.Body>

            <DialogFooter onClose={onClose} />
        </div>
    );
};
